import { useTranslation } from 'react-i18next';

import { CourseRole } from '../../../../../../../../db/shared/types';
import { i18nNS } from '../../../../../../../../i18n';
import { commentCreatorClasses, Role, StyledCourseUserCell, StyledUserCell } from './styles';
import useCommentCreatorVM, { Props as VMProps } from './vm';

interface Props extends VMProps {
  className?: string;
}

const CommentCreator = ({ className, ...vmOptions }: Props) => {
  const { t } = useTranslation([i18nNS.COMMENTS, i18nNS.COMMON, i18nNS.GLOSSARY]);

  const { creator } = vmOptions;
  const { courseRole, isRemovedMember, createdOnFormattedTime } = useCommentCreatorVM(vmOptions);

  // students can only be anonymous
  if (creator.isAnonymous) {
    return (
      <StyledUserCell
        size="medium"
        avatar={creator.avatar}
        title={creator.name}
        subtitle={createdOnFormattedTime}
        className={className}
        classes={{
          avatar: commentCreatorClasses.avatar,
          content: commentCreatorClasses.content,
          subtitle: commentCreatorClasses.subtitle,
        }}
      />
    );
  }

  return (
    <StyledCourseUserCell
      size="medium"
      isCourseRoleNeeded
      existingCourseRole={creator.role}
      avatar={creator.avatar}
      subtitle={createdOnFormattedTime}
      action={
        isRemovedMember
          ? creator.role !== CourseRole.STUDENT && (
              <Role aria-hidden label={t(creator.role, { ns: i18nNS.GLOSSARY })} />
            )
          : courseRole &&
            courseRole !== CourseRole.STUDENT && (
              <Role aria-hidden label={t(courseRole, { ns: i18nNS.GLOSSARY })} />
            )
      }
      className={className}
      classes={{
        avatar: commentCreatorClasses.avatar,
        content: commentCreatorClasses.content,
        subtitle: commentCreatorClasses.subtitle,
      }}
      ariaLabel={(name, role) => {
        if (role === CourseRole.STUDENT) {
          return t('name_posted_datetime', { ns: i18nNS.COMMENTS, name, dateTime: createdOnFormattedTime });
        }
        return t('role_name_posted_datetime', {
          ns: i18nNS.COMMENTS,
          role,
          name,
          dateTime: createdOnFormattedTime,
        });
      }}
      hideAriaContent
    />
  );
};

export default CommentCreator;
